<template>
  <div class="home">
    <BookGallery :year="$route.params.year" />
  </div>
</template>

<script>
  import BookGallery from '../components/BookGallery';
  export default {
    name: 'YearPage',
    components: {
      BookGallery
    },
    mounted() {

    }
  }
</script>


// WEBPACK FOOTER //
// resources/js/pages/YearPage.vue